import type { CreanceRow } from "@/lib/creance.api";
import { getCreanceInvoiceLabel, parseAmount } from "./creance-formatters";

export interface CreanceMetrics {
  totalPrincipal: number;
  totalPenalty: number;
  overdueCount: number;
  totalExpected: number;
  totalPaid: number;
}

export function getTotalDue(row: CreanceRow): number {
  return parseAmount(row.principalDue) + parseAmount(row.penaltyDue);
}

export function getCreanceMetrics(rows: CreanceRow[]): CreanceMetrics {
  return {
    totalPrincipal: rows.reduce((sum, row) => sum + parseAmount(row.principalDue), 0),
    totalPenalty: rows.reduce((sum, row) => sum + parseAmount(row.penaltyDue), 0),
    overdueCount: rows.filter((row) => row.isOverdue).length,
    totalExpected: rows.reduce((sum, row) => sum + parseAmount(row.expectedAmount), 0),
    totalPaid: rows.reduce(
      (sum, row) => sum + parseAmount(row.principalPaid) + parseAmount(row.penaltyPaid),
      0,
    ),
  };
}

export function filterCreances(rows: CreanceRow[], search: string): CreanceRow[] {
  const needle = search.trim().toLowerCase();
  if (!needle) return rows;

  return rows.filter((row) =>
    [
      getCreanceInvoiceLabel(row),
      row.invoiceId,
      row.partyName,
      row.partyId,
      row.sequence,
      row.expectedDate,
      row.principalDue,
      row.penaltyDue,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(needle),
  );
}
